function fireEvent({ eventName, eventAttributes }) {
  if (typeof eventName === 'undefined') {
    throw new TypeError('eventName must be defined');
  }

  const event = { event: eventName, ...eventAttributes };

  window.dataLayer.push(event);
}

export default fireEvent;
